import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface ExamEditTemplateProps {
  readonly exam: { title?: string | null };
  readonly tabs: ReactNode;
  readonly children?: ReactNode;
  readonly onEdit?: () => void;
}

export function ExamEditTemplate({ exam, tabs, children }: ExamEditTemplateProps) {
  const { t } = useTranslation('examManagement');

  return (
    <div className="flex flex-col gap-nano">
      {/** Breadcrumb */}
      <Breadcrumb>
        <BreadcrumbLink>
          <Link to="/">
            <BreadcrumbIcon />
          </Link>
        </BreadcrumbLink>

        <BreadcrumbLink>
          <Link to={'/exams' as never} search={{} as never}>
            {t('breadcrumb.exams')}
          </Link>
        </BreadcrumbLink>

        <BreadcrumbPage>{exam.title ?? ''}</BreadcrumbPage>
      </Breadcrumb>

      <h1 className="ts-heading-lg text-ctx-content-title mb-xxs">{exam.title ?? ''}</h1>

      <div className="rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface p-md shadow-level1">
        {tabs}
      </div>

      {children}
    </div>
  );
}
